import NProgress from "nprogress";
import Router from "next/router";

if (process.env.NEXT_MODE === "spa") {
    NProgress.configure({
        easing: "ease",
        speed: 800,
        minimum: 0.5,
        trickle: false
    });

    Router.events.on("routeChangeStart", () => {
        NProgress.start();
    });
    Router.events.on("routeChangeComplete", () => NProgress.done());
    Router.events.on("routeChangeError", () => NProgress.done());
}
